import styled from 'styled-components';

type DescriptionType = {
  $color: string;
};

export const Warnings = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const WarningItem = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
`;

export const Icon = styled.div`
  padding-top: 4.5px;

  & > svg {
    display: block;
  }
`;

export const Description = styled.span<DescriptionType>`
  font-size: 14px;
  line-height: 150%;
  text-align: start;
  color: ${(props) => props.$color};
`;
